import React, { useEffect } from "react";
import BackBar from "../../../common/nav/BackBar";
import styles from "./Settings.module.scss";
import SonicLink from "../../routing/SonicLink";

type Props = {
  type: string;
  description: string;
  link: string;
  tutorial: React.ReactNode;
  currentMenu?: number;
  children?: React.ReactNode;
};

const Settings: React.FC<Props> = ({
  type,
  description,
  link,
  tutorial,
  currentMenu,
  children,
}) => {
  useEffect(() => {
    // Prevents scrolling when opening menu on smarthphone
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    if (!mediaQuery.matches) {
      const html = document.querySelector("html");
      if (html) {
        if (currentMenu !== undefined) {
          html.style.overflowY = "hidden";
        } else {
          html.style.overflowY = "unset";
        }

        currentMenu !== undefined
          ? (html.style.overflowY = "hidden")
          : (html.style.overflowY = "unset");

        return () => {
          html.style.overflowY = "unset";
        };
      }
    }
  }, [currentMenu]);

  return (
    <div className={styles["p-dbsettings"]}>
      <div className={styles["p-dbsettings__wrapper"]}>
        <BackBar
          title={`${type}設定`}
          editable={false}
          handleClose={() => history.back()}
        />
        <div className={styles["p-projectSettings__head"]}>
          <h1 className={styles["p-projectSettings__head__title"]}>
            {`新規${type}`}
          </h1>
          <div className={styles["p-projectSettings__head__subtitle"]}>
            {description}
            <br />
            <span>※公開時にSELeCT運営による審査があります。</span>
            <br />
            詳しくは &nbsp;<SonicLink to="/info/guide">ご利用ガイド</SonicLink>
            &nbsp;をご覧ください。
            {type === "プロフィール" ? (
              <div
                className={styles["p-projectSettings__head__subtitle-notice"]}
              >
                プロフィールはSELeCTに公開されます。個人情報の入力はお控えください。
                <br />
                ご連絡先は
                <SonicLink to="/mypage/other-settings">こちら</SonicLink>
                から入力いただけます。
              </div>
            ) : null}
          </div>
          <div className={styles["p-projectSettings__head__link"]}>
            <SonicLink to={link}>{type}を作成</SonicLink>
          </div>
        </div>
        {children ? (
          <div className={styles["p-projectSettings__list"]}>
            <div className={styles["p-projectSettings__list-title"]}>
              作成した{type}一覧
            </div>
            {type === "プロジェクト" ? (
              <div className={styles["p-projectSettings__support-text"]}>
                <p>
                  応募者に関する情報は、SELeCT運営からメールにてご連絡いたします。
                </p>
              </div>
            ) : null}
            {children}
          </div>
        ) : (
          tutorial
        )}
      </div>
    </div>
  );
};

export default Settings;
